import app from "@/main";

/**
 * Add a +234 country code to phone number
 *
 * @param {String} phoneNo
 */
export const appendNgCountryCode = phoneNo => {
  if (phoneNo.includes("+234")) return phoneNo;
  return phoneNo[0] === "0" ? `+234${phoneNo.slice(1)}` : `+234${phoneNo}`;
};

export const formatPercent = number => {
  const formatter = new Intl.NumberFormat(`en-NG`, {
    style: "percent",
    minimumFractionDigits: 2
  });
  return formatter.format(number);
};

/**
 * Formats money
 * @param {String} amount
 * @param {Boolean} addSign
 */
export const formatMoney = (
  number = 0,
  countryCode = "NG",
  currencyCode = "NGN"
) => {
  if (isNaN(parseFloat(countryCode))) {
    countryCode = "NG";
  }
  if (isNaN(parseFloat(currencyCode))) {
    currencyCode = "NGN";
  }
  const formatter = new Intl.NumberFormat(`en-${countryCode}`, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2
  });

  if(isNaN(number)) {
    return formatter.format(0);
  }
  
  return formatter.format(number);
};
/**
 * Captilize first letter of a string
 *
 * @param {String} str
 */
export const capitalizeFirstLetter = str => {
  if (str === null) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Generate a toast
 * @param {Object} toastData
 * @param {String} toastData.message
 * @param {Number} toastData.autoHideDelay
 * @param {Boolean} toastData.appendToast
 * @param {String} toastData.variant
 */
export const createToast = ({
  message,
  autoHideDelay = 3500,
  appendToast = false,
  variant = "success"
}) => {
  app.$bvToast.toast(message, {
    toaster: "b-toaster-top-center",
    autoHideDelay,
    appendToast,
    variant
  });
};

import nigerianBanks from "./nigerianBanks";
export const bankLogo = code => {
  const name = nigerianBanks[code].toLowerCase().replace(/\s/g, "_");
  return require(`@/assets/icons/bank-logos/${name}.svg`);
};

export const smoothScroll = (duration = 1000) => {
  let cosParameter = window.scrollY / 2,
    scrollCount = 0,
    oldTimestamp = performance.now();

  function step(newTimestamp) {
    scrollCount += Math.PI / (duration / (newTimestamp - oldTimestamp));
    if (scrollCount >= Math.PI) window.scrollTo(0, 0);
    if (window.scrollY === 0) return;
    window.scrollTo(
      0,
      Math.round(cosParameter + cosParameter * Math.cos(scrollCount))
    );
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
};
